import { Crown } from "@phosphor-icons/react";

// LifetimeBadge — gold-foil pill for permanent premium members.
// Three sizes (xs / sm / md) so it fits anywhere (sidebar pill, page headers, etc.).
// Pure presentational; pass `member` (the user object) and it renders nothing
// for non-lifetime users — drop it anywhere safely.

const SIZE_CLASSES = {
  xs: "px-1.5 py-0.5 text-[9px] gap-1",
  sm: "px-2 py-0.5 text-[10px] gap-1",
  md: "px-3 py-1 text-xs gap-1.5",
};
const ICON_SIZE = { xs: 8, sm: 10, md: 12 };

export default function LifetimeBadge({
  member,
  size = "sm",
  showLabel = true,
  testId = "lifetime-badge",
}) {
  const isLifetime =
    member?.is_lifetime_premium === true ||
    member?.subscription_status === "lifetime";
  if (!isLifetime) return null;

  const sizeCls = SIZE_CLASSES[size] || SIZE_CLASSES.sm;

  return (
    <span
      data-testid={testId}
      title="Lifetime member — permanent premium access"
      className={`inline-flex items-center font-mono font-bold uppercase tracking-widest border-2 border-zinc-900 bg-gradient-to-br from-amber-300 via-amber-400 to-amber-500 text-zinc-900 ${sizeCls} shadow-[2px_2px_0_0_rgba(24,24,27,1)] select-none align-middle`}
    >
      <Crown size={ICON_SIZE[size] || 10} weight="fill" />
      {showLabel && <span>Lifetime</span>}
    </span>
  );
}
